export default __webpack_public_path__ + "static/media/testimonials.f6e64f5c.png";